import { LicenseUser } from '../models/license-user';
import { partnerSettingsSnapshot } from '../repositories/app-settings/app-settings.repository';
import { assetStoreSnapshot } from '../repositories/assets/assets.repository';
import { determineMainDriver } from './determine-main-driver';

export function createDriverIdLookup() {
  const lookup =
    partnerSettingsSnapshot().integrationType === 'DriverId'
      ? ({ externalId }: LicenseUser) =>
          assetStoreSnapshot().linkedVehicleMap.get(externalId ?? '')
      : ({ externalId }: LicenseUser) =>
          determineMainDriver(
            assetStoreSnapshot().linkedDriverMap.get(externalId ?? '') ?? {
              vehicleId: '',
              vehicleDriverLinks: [],
            }
          );

  return (asset: LicenseUser) => lookup(asset)?.integrationDriverId ?? '';
}
